
export const formatDateDayShort = (date) => {
    const options = { weekday: 'long', month: 'long', day: 'numeric' };
    return new Date(date).toLocaleDateString('en-GB', options);
};

export const formatDateEN = (date) => {
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
    return new Date(date).toLocaleDateString('en-GB', options);
};

export const formatFullDateEN = (date) => {
    //25/12/2023
    const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }
    return new Date(date).toLocaleDateString('en-GB', options)
}
export const isToday = (someDate) => {
    const today = new Date()
    return someDate.getDate() == today.getDate() &&
        someDate.getMonth() == today.getMonth() &&
        someDate.getFullYear() == today.getFullYear()
}
export const formatDateYMD = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
export const formatDateTimeEN = (date) => {
  //25/12/2023 11:45:00
  const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
  var formatDate = new Date(date).toLocaleDateString('en-GB', options);
  var formatTime = new Date(date).toLocaleTimeString('en-GB');
  return formatDate+' '+formatTime;
}
// check if a variable is a timestamp (number) or an ISO string (string)
export const isTimestampOrISOString = (val) => {
 // Check if it's a number (timestamp) 
  if (typeof val === 'number') {
    return 'timestamp';
  }
  // Check if it's a string and matches ISO 8601 format
  if (typeof val === 'string' && val.trim() !== '') {
    // Simple ISO 8601 regex (covers most cases)
    const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;
    // Extended ISO 8601 regex with milliseconds: "2025-06-12 16:05:22.989";
    const isoRegex2 = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}\.\d{3}$/;
    if (isoRegex.test(val) || isoRegex2.test(val)) {
      return 'isostring';
    } 
  }
  return 'unknown';
}
//get the difference in miliseconds between 2 dates
export const timeDiff = (lasttimestamp, tagtimestamp) => {
  console.log("timeDiff called with", lasttimestamp, tagtimestamp);
  //console.log("timeDiff isTimestampOrISOString", isTimestampOrISOString(String(lasttimestamp)), isTimestampOrISOString(String(tagtimestamp)));
  if (isTimestampOrISOString(lasttimestamp) == "timestamp" && isTimestampOrISOString(tagtimestamp) == "timestamp")
  {
    const date1 = new Date(parseInt(lasttimestamp));
    const date2 = new Date(parseInt(tagtimestamp));
    return  Math.abs(date2.getTime() - date1.getTime());
  }
  else if (isTimestampOrISOString(lasttimestamp) == "isostring" && isTimestampOrISOString(tagtimestamp) == "isostring")
  {
    // Parse the strings into Date objects
    const d1 = new Date(lasttimestamp);
    const d2 = new Date(tagtimestamp);

    //console.log("timeDiff comparing", d1, d2);
    console.log("timeDiff diff", Math.abs(d2 - d1));
    // Get the absolute difference in milliseconds
    return Math.abs(d2 - d1);
  }
  else {
    return null;
  }
}
export const formatLondon = (dateVar) => {
  let date ;
  //console.log(dateVar);
  if(isTimestampOrISOString(dateVar) == "unknown" ) {
    return dateVar;
  }
  if(isTimestampOrISOString(dateVar) == "isostring") {
    //console.log("isostring");
    date = new Date(dateVar);
  }
  else if(isTimestampOrISOString(dateVar) == "timestamp") {
    //console.log("is timestamp");
    date = new Date(dateVar * 1000);
  }

  //console.log(date);
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    timeZone: 'Europe/London'
  };
  const parts = new Intl.DateTimeFormat('en-GB', options).formatToParts(date);
  const get = type => parts.find(p => p.type === type).value;
  const ms = String(date.getMilliseconds()).padStart(3, '0');
  return `${get('year')}-${get('month')}-${get('day')} ${get('hour')}:${get('minute')}:${get('second')}.${ms}`;
}

//convert date format from DD/MM/YYYY to YYYY-MM-DD
export const convertDateToYMD = (dateStr) => {
  //if dateStr is empty, return empty
  if (!dateStr) return '';
  //if is already in YYYY-MM-DD format, return as is
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;
  //split by /
  const [day, month, year] = dateStr.split('/');
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
}